import React from 'react';
import cn from 'classnames';

import {IAuthLoginProps} from './IAuthLogin';
import {AuthLoginContent, AuthLoginForm} from './Subcomponents';

import styles from './AuthLogin.module.scss';

const AuthLogin = ({classNames, onCancel, onSuccess}: IAuthLoginProps) => {
	return (
		<div className={cn('auth-login', styles['auth-login'])}>
			<AuthLoginForm onSuccess={onSuccess} classNames={classNames} />
			<AuthLoginContent onClick={onCancel} classNames={classNames} />
		</div>
	);
};

export default AuthLogin;
